import { render, staticRenderFns } from "./ProductInformation.vue?vue&type=template&id=182f3d57&scoped=true"
import script from "./ProductInformation.vue?vue&type=script&lang=js"
export * from "./ProductInformation.vue?vue&type=script&lang=js"
import style0 from "./ProductInformation.vue?vue&type=style&index=0&id=182f3d57&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "182f3d57",
  null
  
)

export default component.exports